import axios from 'axios';

class RegistrationClient {
    static checkSite(siteName, denomination, inKRZ) {
        return axios.post('/api/checksite', { siteName, denomination, inKRZ });
    }

    static checkSiteExists(siteName, inKRZ) {
        return axios.get(`/api/checksiteexists/${siteName}/${inKRZ}`);
    }

    static changeEmail(email, token) {
        return axios.post('/api/register/email', { email: email, token: token });
    }

    static validateEmail(validationToken) {
        return axios.get(`/api/validate/${validationToken}`);
    }

    static setupStatus(token, callback, errorCallback) {
        axios
            .get(`/api/setupstatus/${token}`)
            .then(result => {
                callback(result.data);
            })
            .catch(error => {
                errorCallback(error);
            });
    }

    static sendRegistration(registrationData) {
        return axios.post('/api/register', registrationData);
    }

    static getRegisterDataByToken(token, callback) {
        axios.get(`/api/register/${token}`).then(result => {
            callback(result.data);
        });
    }

    static resendValidationMail(token, callback) {
        return axios.post('/api/register/resend', { resendToken: token });
    }

    static getSetupMeetingOptions() {
        return axios.get(`/api/setupmeetings`);
    }
}

export default RegistrationClient;
